import { stringify } from 'qs';
import request from '../request';
import { url } from '../service-utils';

/**
 * 推送规则列表
 * 页面：安全报告推送管理页
 * 前端：洪芳
 * 后端： 范腾
 * @params {Object} params: demo传参对象
 */
export async function schoolAllSecurityRules(params) {
  return request(
    `${url.studentAttendance}/attendance2/web/studentkq/security/schoolAllSecurityRules?${stringify(
      params
    )}`
  );
}

/**
 * 安全报告推送规则删除接口
 * 页面：安全报告推送管理页
 * 前端：洪芳
 * 后端： 范腾
 * @params {Object} params: demo传参对象
 */
export async function deletePushRule(params) {
  return request(
    `${url.studentAttendance}/attendance2/web/studentkq/security/deletePushRule?${stringify(
      params
    )}`
  );
}


/**
 * 推送规则列表
 * 页面：安全报告推送管理页
 * 前端：洪芳
 * 后端： 范腾
 * @params {Object} params: demo传参对象
 */
export async function getDeptDetail(params) {
  return request(
    `${url.studentAttendance}/attendance2/web/studentkq/security/deptDetail?${stringify(
      params
    )}`
  );
}

